import moment from 'moment'

import { Patient } from 'store/types'

type DuplicatePatientCandidate = {
  firstName?: string | null
  lastName?: string | null
  dob?: string | null
}

type LegacyPatientLike = {
  first_name?: string | null
  last_name?: string | null
  dob?: string | null
}

type DuplicatePatientRecord = Partial<Patient> & LegacyPatientLike

const DOB_FORMATS = ['MM/DD/YYYY', 'MM-DD-YYYY', 'YYYY-MM-DD', moment.ISO_8601]

const normalizeName = (value?: string | null): string =>
  String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '')

const normalizeDob = (value?: string | null): string => {
  if (!value) {
    return ''
  }

  const parsed = moment(value, DOB_FORMATS, true)

  if (parsed.isValid()) {
    return parsed.format('YYYYMMDD')
  }

  const fallback = moment(value)
  return fallback.isValid() ? fallback.format('YYYYMMDD') : ''
}

const getFirstName = (patient: DuplicatePatientRecord): string | null | undefined =>
  patient.firstName ?? patient.first_name

const getLastName = (patient: DuplicatePatientRecord): string | null | undefined =>
  patient.lastName ?? patient.last_name

export const findDuplicatePatients = <T extends DuplicatePatientRecord>(
  candidate: DuplicatePatientCandidate,
  patients: T[] = [],
): T[] => {
  const normalizedFirstName = normalizeName(candidate.firstName)
  const normalizedLastName = normalizeName(candidate.lastName)
  const normalizedDob = normalizeDob(candidate.dob)

  if (!normalizedFirstName || !normalizedLastName || !normalizedDob) {
    return []
  }

  return patients.filter((patient) => {
    return (
      normalizeName(getFirstName(patient)) === normalizedFirstName
      && normalizeName(getLastName(patient)) === normalizedLastName
      && normalizeDob(patient.dob) === normalizedDob
    )
  })
}
